import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle, LinearProgress, Typography } from '@mui/material';

interface ConfirmationDialogProps {
  loading?: boolean;
  title?: string;
  cancelLabel?: string;
  confirmLabel?: string;
  onCancel: () => void;
  onConfirm?: () => void;
  children?: React.ReactNode;
  open?: boolean;
  message?: string;
}

export function ConfirmationDialog(props: ConfirmationDialogProps) {
  const {
    open = true,
    loading = false,
    title = 'Potvrdenie',
    cancelLabel = 'Nie',
    confirmLabel = 'Áno',
    onCancel,
    onConfirm,
    children,
  } = props;
  return (
    <Dialog open={open} fullWidth maxWidth="xs" onClose={onCancel}>
      <DialogTitle>{title}</DialogTitle>
      <DialogContent>
        {children}
        {props.message && <Typography variant="body1">{props.message}</Typography>}
      </DialogContent>
      <DialogActions>
        <Button disabled={loading} onClick={onCancel}>
          {cancelLabel}
        </Button>

        {onConfirm && (
          <Button disabled={loading} onClick={onConfirm} variant="contained" color="primary">
            {confirmLabel}
          </Button>
        )}
      </DialogActions>
      {loading && <LinearProgress />}
    </Dialog>
  );
}
